/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Users_Invite_Email_SentInputs */

const cs_settings_users_invite_email_sent = /** @type {(inputs: Settings_Users_Invite_Email_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail s pozvánkou byl odeslán.`)
};

const en_settings_users_invite_email_sent = /** @type {(inputs: Settings_Users_Invite_Email_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invite email was sent.`)
};

/**
* | output |
* | --- |
* | "Invite email was sent." |
*
* @param {Settings_Users_Invite_Email_SentInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_users_invite_email_sent = /** @type {((inputs?: Settings_Users_Invite_Email_SentInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Users_Invite_Email_SentInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_users_invite_email_sent(inputs)
	return cs_settings_users_invite_email_sent(inputs)
});